import { Badge } from '@/components/ui/badge'
import { datasetKindLabel } from '@/pages/KnowledgeHubPage/libraryHelpers'
import type { DatasetKindChipProps } from '@/types/components/dataset-kind-chip'

export function DatasetKindChip({ kind, className }: DatasetKindChipProps) {
  return (
    <Badge variant="muted" className={className} data-testid="dataset-kind-chip">
      {datasetKindLabel(kind)}
    </Badge>
  )
}
